// Constant
import { FAKE_RESPONSE } from 'constant/shared.constant'

// Interfaces
import { IAboutUsMottoApiGetResponse } from 'interfaces/back-office/content-management/about-us/motto/about-us-motto-api.interface'
// Moment
import moment from 'moment'

export const ABOUT_US_MOTTO: IAboutUsMottoApiGetResponse = {
  ...FAKE_RESPONSE,
  res: {
    message: 'Get About Us Motto Success',
    success: '1',
    data: {
      id: 1,
      content: 'Content',
      status: true,
      createdAt: moment().toString(),
      updatedAt: moment().toString(),
    },
  },
}
